/**
 * ProgressBar — sky-fill horizontal bar.
 *
 * Used by the S04 import-preview confidence rows ("Customers 96% ▮▮▮▯▯").
 * Pure presentational; no a11y `role="progressbar"` is added because the value
 * is shown numerically next to the bar — duplicating the announcement is
 * worse for screen readers than omitting it.
 */
import * as React from "react";
import { cn } from "../lib/cn.js";

export interface ProgressBarProps extends React.HTMLAttributes<HTMLDivElement> {
  /** 0 — 100. Values outside the range are clamped. */
  value: number;
  /** Track height in px. Prototype uses 7px. */
  height?: number;
}

export function ProgressBar({ value, height = 7, className, style, ...props }: ProgressBarProps) {
  const pct = Math.max(0, Math.min(100, value));
  return (
    <div
      className={cn("relative w-full overflow-hidden rounded-full bg-raised", className)}
      style={{ height, ...style }}
      {...props}
    >
      <div
        className="absolute inset-y-0 left-0 rounded-full bg-accent"
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
